import { FC } from 'react'

import usePrinter from 'src/hooks/usePrinter'
import useQueryParams from 'src/hooks/useQueryParams'
import useTracking from 'src/hooks/useTracking'
import DropdownMenuItem from '../../../atoms/DropdownMenuItem'
import DownloadIcon from '../../../atoms/Icons/DownloadIcon'

const DownloadDashboardMenu: FC = () => {
  const { trackEvent } = useTracking()
  const { setQueryParams } = useQueryParams()
  const { setPrintMode } = usePrinter()

  return (
    <DropdownMenuItem
      icon={<DownloadIcon className="text-hit-gray" />}
      label="Download"
      data-testid="header-dashboard-menu-download"
      onClick={() => {
        setQueryParams({ download_pdf: true })
        trackEvent({ action: 'Click: Download PDF icon' })
        setPrintMode(true)
      }}
    />
  )
}

export default DownloadDashboardMenu
